import * as React from "react";
import { IconButton, Pane, Button, EditIcon, TickCircleIcon, BanCircleIcon, TextInput, toaster, Text } from 'evergreen-ui';
import './EditName.scss';
export function EditName(props) {
    const editEL = React.useRef(null);
    var ext = props.value.substr(props.value.lastIndexOf('.'));
    const [saving, setSaving] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [value, setValue] = React.useState(props.value.substr(0, props.value.lastIndexOf('.')));
    const editFileName = function () {
        let e = value;
        if (e == null || e == '') {
            toaster.danger("Filename can not be blank");
            return;
        }
        if (e.includes('.')) {
            e = e.split('.')[0];
        }
        let sChar = ['/', '@', '!', '#'];
        if (sChar.indexOf(e) >= 0) {
            toaster.danger("Edit contains one of the following special characters : " + sChar.join(','));
            return;
        }
        setEdit(false);
        setSaving(true);
        props.onChange ? props.onChange(e + ext).then(() => {
            setSaving(false);
        }) : setSaving(false);
    };
    return (React.createElement(Pane, { className: 'EditName', margin: 8 },
        !edit && React.createElement(Pane, { display: "flex", flexDirection: 'row', alignItems: "center", onClick: () => setEdit(!edit) },
            React.createElement(Text, null,
                props.value,
                React.createElement(IconButton, { isLoading: saving, icon: EditIcon, intent: "success", appearance: "minimal", marginLeft: 8 }))),
        edit && React.createElement(Pane, { display: "flex" },
            React.createElement(TextInput, { value: value, onChange: (e) => { setValue(e.target.value); } }),
            React.createElement(Button, { onClick: () => { editFileName(); } },
                React.createElement(TickCircleIcon, { color: "success" })),
            React.createElement(Button, { onClick: () => { setEdit(false); } },
                React.createElement(BanCircleIcon, { color: "danger" })),
            " ")));
}
